import React from 'react'
import { ModalFormWrapper } from '../../../../../itrust_common/components/others'
import NewCountryForm from './NewCountryForm'
import { countryCreate, countryEditCancel } from '../../../../../redux/actions/manageCountriesActions'
import { connect, useDispatch } from 'react-redux'
import * as $ from 'jquery';

function NewCountryModal(props) {
  const { editing, saving } = props
  const dispatch = useDispatch()

  const handleCountryEditCancel = () => {
    dispatch(countryEditCancel())
    $('#newCountryForm-modal').modal('hide');
  }

  const handleCreateNewCountry = async (data) => {
    await dispatch(countryCreate(data))
    $('#newCountryForm-modal').modal('hide');
  }

  return (
    <ModalFormWrapper
      formName="newCountryForm"
      formTitle="Create New Country"
      handleEditCancel={handleCountryEditCancel}
      saving={saving}
    >
      {editing?.id && <NewCountryForm
        onSubmit={handleCreateNewCountry}
      />}
    </ModalFormWrapper>
  )
}

const mapStateToProps = state => {
  const { manageCountries } = state;
  return {
    editing: manageCountries.editing,
    saving: manageCountries.saving,
  }
}
export default connect(mapStateToProps)(NewCountryModal);